import { useDeleteMutation, usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<
  typeof useDeleteMutation<z.ZodUndefined, z.ZodUndefined>
>[3];

export const useDeleteCompanyMember = (id: number, config?: Config) => {
  return useDeleteMutation(
    z.undefined(),
    z.undefined(),
    `/app/company_users/${id}`,
    config,
  );
};